module.exports = __webpack_public_path__ + "img/boy_010004.c70abad4.png";